"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_HOST_ACCOUNT_MUTATION = exports.CREATE_BUSINESS_GUEST_ACCOUNT_MUTATION = exports.CREATE_STANDARD_GUEST_ACCOUNT_MUTATION = exports.AUTHENTICATE_USER_MUTATION = void 0;
exports.AUTHENTICATE_USER_MUTATION = `
  mutation AuthenticateGuest($input: AuthenticateGuestInput!) {
    authenticateGuest(input: $input) {
      jwt
      refreshToken
      user {
        id
        companyName
        country
        email
        firstName
        lastName
        roles
        companyID
        avatar
      }
    }
  }
`;
exports.CREATE_STANDARD_GUEST_ACCOUNT_MUTATION = `
  mutation CreateStandardGuestAccount($input: CreateStandardGuestAccountInput!) {
    createStandardGuestAccount(input: $input) {
      refreshToken
      jwt
      user {
        id
        companyName
        country
        email
        firstName
        lastName
        roles
        companyID
        avatar
      }
    }
  }
`;
exports.CREATE_BUSINESS_GUEST_ACCOUNT_MUTATION = `
  mutation CreateBusinessGuestAccount($input: CreateBusinessGuestAccountInput!) {
    createBusinessGuestAccount(input: $input) {
      refreshToken
      jwt
      user {
        id
        companyName
        country
        email
        firstName
        lastName
        roles
        companyID
        avatar
      }
    }
  }
`;
exports.CREATE_HOST_ACCOUNT_MUTATION = `
  mutation CreateHostAccount($input: CreateHostAccountInput!) {
    createHostAccount(input: $input) {
      refreshToken
      jwt
      user {
        id
        companyName
        country
        email
        firstName
        lastName
        roles
        companyID
        avatar
      }
    }
  }
`;
